import { gql } from '@apollo/client';
import { GroupFragment } from 'graphql/Group/fragments/GroupFragment';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
/**
 * @fragment UserFragment
 * @since 1.0.0
 */
export const UserFragment = gql `
  fragment UserFragment on User {
    id
    firstname
    lastname
    fullname
    email
    phone
    extension
    title
    active
    createdAt
    updatedAt

    group {
      ...GroupFragment
    }

    account {
      id
      tag
    }

    image {
      ...MediaFragment
    }

    language {
      ...LanguageFragment
    }
  }

  ${GroupFragment}
  ${MediaFragment}
  ${LanguageFragment}
`;
